export const parseValue = (value, defaultValue = null) => {
  try {
    return JSON.parse(value) ?? defaultValue
  } catch {
    return value ?? defaultValue
  }
}

const urlParams = () => new URLSearchParams(window.location.search)

export const getParams = (defaultValue) => {
  return {
    get(key, instanceDefaultValue) {
      const params = urlParams()
      return parseValue(params.get(key), instanceDefaultValue ?? defaultValue)
    },

    toJSON() {
      const params = urlParams()
      const entries = Object.fromEntries(params)
      const j = {}

      Object.entries(entries).forEach(([key, value]) => {
        const v = parseValue(value, defaultValue)

        if (value !== null || typeof value !== 'undefined') {
          j[key] = v
        }
      })

      return j
    },

    toString: () => {
      const params = urlParams()
      return params.toString()
    }
  }
}
